import React, { Fragment, useEffect, useState } from 'react'
import { getSession } from '../../utils/api'
import { mfeConfigs } from '../../utils/mfe'
import { SingleSpaParcel } from './SingleSpaParcel'
import { RouteConstants } from '../../utils/constants'
import { isFeatureFlagEnable } from '../../api/unleash'
import { UnleashToggles } from '../../types/unleashToggles'

export const FeesPage = (props) => {
  const session = getSession()
  const authToken = session ? session.accessToken : null
  const [isMFEFeesPageEnabled, setIsMFEFeesPageEnabled] = useState(false)

  useEffect(()=>{
    checkIsMFEFeesPageEnabled()
  }, [])

  const checkIsMFEFeesPageEnabled = async ()=>{
    let isMFEFeesPageEnabled = localStorage.getItem('isMFEFeesPageEnabled') === 'true'
    if(isMFEFeesPageEnabled == null){
      isMFEFeesPageEnabled = await isFeatureFlagEnable(UnleashToggles.CAN_USE_FEES_MFE)
    }
    setIsMFEFeesPageEnabled(isMFEFeesPageEnabled)
  }

  return (
    (isMFEFeesPageEnabled ?
      (
        <SingleSpaParcel
          {...props}
          basename={RouteConstants.FEES().BASE}
          authToken={authToken}
          origin='blu'
          merchantId={props.merchantId}
          config={mfeConfigs.LOAD_FEES_PAGE}
        />
      )
      :(<Fragment></Fragment>)
    )
  )
}




// WEBPACK FOOTER //
// ./src/components/MfeParcels/FeesPage.js